module.exports = __webpack_public_path__ + "static/media/icon_zoom_in.0a6558c5.svg";